<template>  
    <div>  
      <div id="QR_code" ></div>  
    </div>  
  </template>  
  
  <script>  
  export default {  
    props: {  
      visible: { // 控制组件是否可见的属性  
        type: Boolean,  
        default: false  
      },  
      appid: { // 微信应用的 ID  
        type: String,  
        required: true  
      },  
      redirectUri: { // 替换为你的重定向 URI  
        type: String,  
        required: true  
      },  
      state: { // 自定义参数  
        type: String,  
        default: () => Math.random().toString(36).substr(2)  
      }  
    },  
    mounted() {  
      
        this.initWxLogin();  
     
      // 添加消息监听  
      window.addEventListener("message", this.handleMessage, false);  
    },  
    beforeDestroy() {  
      window.removeEventListener("message", this.handleMessage, false);  
    },  
    methods: {  
      initWxLogin() {  
        new WxLogin({  
          self_redirect: true,  
          id: "QR_code", // QR 码容器的 ID  
          appid: 'wx13d4a3fa0015eb5c',  
          scope: "snsapi_login",  
          redirect_uri: encodeURIComponent("https://www.hittik.com/wxLogin"),  
          state:Math.random().toString(36).substr(2),
          style: "black",  
          href: "" // 自定义二维码样式  
        });  
      },  
      handleMessage(event) {  
        // 确保来源是可信的  
        // if (event.origin !== 'https://www.hittik.com') return;  
  
        if (event.data.cmd === 'returnFormJson') {  
          const { code ,state} = event.data.params.QR_code;  
          this.$emit('codeReceived', code,state); // 通过事件将 code 发送给父组件  
        }  
      }  
    }  
  };  
  </script>  
  
  <style scoped>  
  /* 添加你想要的样式 */  
  </style>  